<template>
  <div id="app">
    <router-view name="header" />
    <router-view />
    <!-- <div class="jipvio-inquiry">
      <i class="far fa-comments"></i>
    </div> -->
    <router-view name="footer" />
    <!-- 서비스 운영안내 팝업창 
    <POPUP>
      <template v-slot:header>
        <div
          class="serviceHeader"
          style="height:100%; backgroundColor:rgba(128,128,128,.2)"
        >
          <h2 class="title">시범서비스 운영안내</h2>
        </div>
      </template>
      <template v-slot:container>
        <div class="serviceInfo jipvio-text-center">
          <div class="p-25" style="height:100%">
            <div
              class="p-25"
              style="backgroundColor:white; height:100%; display:flex; overflow-y:hidden;"
            >
              <div class="m-auto">
                <p>
                  집비오는 현재 서울 구로구 지역 일부를 대상으로<br />시범운영기간
                  중에 있습니다.
                </p>
                <p>
                  서비스 시범운영기간 중에,<br />사용에 불편하거나 개선해야할
                  사항이 있으면<br />아래 양식을 통해 소중한 의견 부탁드립니다.
                </p>
                <el-button round @click="googleForm()" class="submit_form"
                  ><i class="el-icon-s-order"></i> 의견 제출하기</el-button
                >
                <br />
                <br />
                <p>
                  의견을 제출하신 분들 중 추첨을 통해, <br />집비오 플랫폼
                  이용시 사용 가능한 <br />
                  할인 쿠폰을 드립니다.<br />
                  <span class="jipvio-color1"
                    >중개 수수료 20% 할인 쿠폰(최대 5만원 할인)</span
                  >
                </p>
                <p>
                  보다 더 나은 서비스를 위해 노력하겠습니다.<br />감사합니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </POPUP>
    -->
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import POPUP from "@/pages/components/Jipvio/popUp.vue";
import { button } from "element-ui";
import commonApi from "@/service/common";
//import userApi from "@/service/user";

const {
  //mapGetters: sessionMapGetters,
  mapActions: sessionMapActions
} = createNamespacedHelpers("loginSession"); // mapping loginSession module
export default {
  components: {
    POPUP,
    [button.name]: button
  },

  computed: {
    /*
    ...sessionMapGetters({
      sessionCoCodeMap: "getCoCodeMap",
    }),
    */
  },
  methods: {
    ...sessionMapActions(["saveCoCodeMap", "saveCoCodeMapDetail"]),
    async setCommonCodeMap() {
      let res = await commonApi.getCommonCodeMap();
      if (res.status === 200) {
        this.saveCoCodeMap(res.payload);
      }
      res = await commonApi.getCommonCodeMapDetail();
      if (res.status === 200) {
        this.saveCoCodeMapDetail(res.payload);
      }
    },
    googleForm() {
      window.open(
        "https://docs.google.com/forms/d/e/1FAIpQLSc-mlVw7NbtZYEa7unUxYcFSrEP-CLWm4oF2xAE7kJ_a5w3fA/viewform",
        "_blank"
      );
    }
  },

  created() {
    this.setCommonCodeMap();
  }
};
// Channel Plugin Scripts
/*
(function() {
  var w = window;
  if (w.ChannelIO) {
    return (window.console.error || window.console.log || function() {})(
      "ChannelIO script included twice."
    );
  }
  var ch = function() {
    ch.c(arguments);
  };
  ch.q = [];
  ch.c = function(args) {
    ch.q.push(args);
  };
  w.ChannelIO = ch;
  function l() {
    if (w.ChannelIOInitialized) {
      return;
    }
    w.ChannelIOInitialized = true;
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = "https://cdn.channel.io/plugin/ch-plugin-web.js";
    s.charset = "UTF-8";
    var x = document.getElementsByTagName("script")[0];
    x.parentNode.insertBefore(s, x);
  }
  if (document.readyState === "complete") {
    l();
  } else if (window.attachEvent) {
    window.attachEvent("onload", l);
  } else {
    window.addEventListener("DOMContentLoaded", l, false);
    window.addEventListener("load", l, false);
  }
})();
ChannelIO("boot", {
  pluginKey: "60068652-091d-44dc-9baa-63720cbb1de3"
});
*/
// End Channel Plugin
</script>
<style></style>
